// extracted by mini-css-extract-plugin
module.exports = {"root":"Finish-module--root--1TUWE","divider":"Finish-module--divider--zx-Tn","text":"Finish-module--text--2mFRe"};